import type { MailboxInfo } from "owa-client-types";
import type { DragData } from "owa-dnd/lib/utils/dragDataUtil";
import { DraggableItemTypes } from "owa-dnd/lib/utils/DraggableItemTypes";
import { isMoveCopyCrossAccountNotAllowedPolicy } from "owa-mail-triage-movecopy-importexport/lib/utils/copyMoveItemUtils";

const mailItemDragTypes = new Set<string | null>([
    DraggableItemTypes.MailListItemPart,
    DraggableItemTypes.MailListRow,
    DraggableItemTypes.MultiMailListMessageRows,
    DraggableItemTypes.MultiMailListConversationRows,
]);

export default function isCrossAccountMovePolicyBlockedDrag(dragData: DragData, destinationMailboxInfo: MailboxInfo): boolean {
    if (!mailItemDragTypes.has(dragData.itemType)) {
        return false;
    }
    
    const sourceMailboxInfo = (dragData.itemData as {
        mailboxInfo?: MailboxInfo;
    } | undefined)
        ?.mailboxInfo;
    
    return (!!sourceMailboxInfo &&
        isMoveCopyCrossAccountNotAllowedPolicy(sourceMailboxInfo, destinationMailboxInfo));
}
